const footer: string = "</body></html>";

export default footer;